<div class="launchpad-container" *ngrxLet="vm$ as vm">
  <tpm-news-carousel
    class="carousel"
    [isMobile]="isTileSmall$ | async"
    [marketplaceList]="vm.marketplaceBanner.result"
    [newsList]="vm.news.carouselNews"
    [overlay]="vm.overlay"
    (newsItemClicked)="onNewsCarouselBannerClick($event, vm.overlay)"
    (marketplaceItemClicked)="onMarketplaceBannerClick($event, vm.overlay)"
  ></tpm-news-carousel>
  <tpm-card *ngIf="vm.hasRegulatedPermission" rounded-0 class="toggles-buttons-card">
    <div class="toggles-buttons-container">
      <tpm-segmented-button
        [density]="-1"
        [segments]="segments"
        [active]="vm.overlay"
        (selected)="changeOverlay($any($event))"
        (disableSelected)="changeOverlay($any($event))"
      ></tpm-segmented-button>
    </div>
  </tpm-card>
  <tpm-cards-grid
    [isMobile]="isMobile$ | async"
    [list]="vm.list.result"
    [news]="vm.news.modulesNews"
    (moduleCardClicked)="onTileClick($event)"
    (storytellerButtonClicked)="onStoryTellerClick($event, vm.overlay)"
    (leadButtonClicked)="onLeadClick($event)"
    (productButtonClicked)="onProductManagementClick($event)"
    (innerNewsCardButtonClicked)="onNewsTileCardClick($event)"
    (newsButtonClicked)="onNewsClicked(vm.overlay)"
  ></tpm-cards-grid>
</div>
